import { render } from "./news_event.vue?vue&type=template&id=65915081&scoped=true"
import script from "./news_event.vue?vue&type=script&lang=js"
export * from "./news_event.vue?vue&type=script&lang=js"

import "./news_event.vue?vue&type=style&index=0&id=65915081&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65915081"]])

export default __exports__